import { axiosInstance } from "../httpClient";

// Existing API functions
export const createNewConversation = async (data, clientId) => {
  return axiosInstance.post(`/conversation/${clientId}`, data);
};

export const fetchUserInfo = async (clientId) => {
  return axiosInstance.get(`/conversation/${clientId}/list`);
};

export const fetchSingleConversation = async (conversationId, clientId) => {
  return axiosInstance.get(`/conversation/${clientId}/${conversationId}`);
};

export const renameConversation = async (conversationId, clientId, name) => {
  return axiosInstance.patch(`/conversation/${clientId}/${conversationId}`, {
    name,
  });
};

export const checkForData = async (clientId) => {
  return axiosInstance.get(`/data/${clientId}/check`);
};

export const archiveConversation = async (conversationId, clientId) => {
  return axiosInstance.delete(`/archive/${clientId}/${conversationId}`);
};

export const archiveAllConversation = async (clientId) => {
  return axiosInstance.delete(`/archive/${clientId}/all`);
};
